import { CONTAINER_TYPES } from '../constants/ContainerConstants';
import { SAVED_AUDIENCE_FILTER_TYPE, WEBSITE_FILTER_TYPES } from '../constants/Targeting';
export const checkIsShowAlways = ({
  containerType,
  showCloseButton,
  triggers
}) => containerType === CONTAINER_TYPES.BANNER && !showCloseButton && triggers.showAfterDelay && triggers.delayInSeconds === 0;
export const isSavedAudienceFilter = filter => filter.type === SAVED_AUDIENCE_FILTER_TYPE;
export const isWebsiteFilterGroup = filterGroup => {
  if (filterGroup.type !== 'BOOLEAN') return false;
  const {
    values,
    operator
  } = filterGroup;
  const filters = operator === 'NOT' ? values[0].values : values;
  return filters.some(filter => WEBSITE_FILTER_TYPES.includes(filter.type));
};
export const isBehaviourFilterGroup = filterGroup => {
  if (filterGroup.type !== 'BOOLEAN') return false;
  return !isWebsiteFilterGroup(filterGroup);
};